// IMPORTANT: When changing this enum, you have to change the equivalent enum in ChatUserType.cs
export enum ChatUserType {
  Unknown = 0,
  Caller = 1,
  Dispatcher = 2
}
